import { mapState, mapActions } from "vuex"
import CustomInput from "../../components/crud/custom-input.vue"
import MultiSelectCard from "../../components/crud/multiselect/MultiSelectCard.vue"
import Card from "../../components/UI/Card.vue"
import MultiSelectChip from "../../components/crud/multiselect/MultiSelectChip.vue"
import AppBtn from "../../components/UI/Button.vue"
import { http, Microservices } from "../../utils/http"
import SelectDropdown from "../../components/crud/SelectDropdown.vue"
import SearchDropdownInput from "../../components/crud/SearchDropdownInput.vue"
import ProductSearchModal from "../../components/modals/ProductSearchModal.vue"
import CustomerSearchModal from "../../components/modals/CustomerSearchModal.vue"
const { v4: uuidv4 } = require("uuid")
import { normalizeFrequenciesFromApi } from "../../utils/promotionFrequency"
import { confirmDialog } from "../../utils/common"

const FREQUENCIES = {
    SPECIFIC_DATE: "SPECIFIC_DATE",
    DATE_RANGE: "DATE_RANGE",
    RECURRING: "RECURRING",
}

const FREQUENCY_DB_TYPES = {
    SPECIFIC_DATE: "specificDate",
    DATE_RANGE: "dateRange",
    RECURRING: "recurring",
}
const FREQUENCY_TYPES_BY_UI_TYPE = {
    [FREQUENCIES.SPECIFIC_DATE]: FREQUENCY_DB_TYPES.SPECIFIC_DATE,
    [FREQUENCIES.DATE_RANGE]: FREQUENCY_DB_TYPES.DATE_RANGE,
    [FREQUENCIES.RECURRING]: FREQUENCY_DB_TYPES.RECURRING,
}
const FREQUENCY_DB_RECURRENCE_TYPES = {
    WEEK: "week",
    MONTH: "month",
}

export default {
    components: {
        CustomerSearchModal,
        SelectDropdown,
        Card,
        MultiSelectCard,
        CustomInput,
        MultiSelectChip,
        AppBtn,
        SearchDropdownInput,
        ProductSearchModal,
    },

    data() {
        return {
            weekdays: [
                { title: "S", id: "0" },
                { title: "M", id: "1" },
                { title: "T", id: "2" },
                { title: "W", id: "3" },
                { title: "T", id: "4" },
                { title: "F", id: "5" },
                { title: "S", id: "6" },
            ],
            FREQUENCIES,
            showProductModal: false,
            showCustomerModal: false,
            frequency: FREQUENCIES.SPECIFIC_DATE,
            processing: false,
            name: "",
            searching: "",
            name: "",
            rewardValue: "",
            loading: false,
            editMode: false,
            isPercentage: false,
            editId: "",
            status: true,
            promotionType: "product_discount",
            discountMode: "best_price",
            rewardApplication: "amount_off",
            showOnSalesDashboard: false,
            rewardApplicationOptions: [
                { label: "% off", value: "percentage_off" },
                { label: "$ off", value: "amount_off" },
                { label: "Fixed price", value: "fixed_price" },
            ],

            searchingLocations: false,
            searchingProducts: false,
            searchingCustomerGroups: false,
            searchingCategories: false,
            searchingBrands: false,
            searchingSuppliers: false,
            searchingMasterProducts: false,
            masterProductSearchMessage: "Type at least 2 characters to search.",

            selectedLocations: [],
            selectedProducts: [],
            selectedCustomerGroups: [],
            selectedCategories: [],
            selectedBrands: [],
            selectedSuppliers: [],
            selectedMasterProducts: [],

            frequencies: [],
            locations: [],
            products: [],
            productSkuOptionCache: {},
            categories: [],
            brands: [],
            suppliers: [],
            masterProducts: [],
            masterProductOptionCache: {},
            customerGroups: [],

            customerSearchTimeout: null,
            productSearchTimeout: null,
            patternSearchTimeout: null,
            categorySearchTimeout: null,
            brandSearchTimeout: null,
            supplierSearchTimeout: null,
            masterProductSearchTimeout: null,
            activeWeekdayIndex: "",
            allLocations: false,

            productSelectionMode: 'all',
            productSelectionModes: [
                { label: 'All Products', value: 'all' },
                { label: 'Categories', value: 'categories' },
                { label: 'Brands', value: 'brands' },
                { label: 'Suppliers', value: 'suppliers' },
                { label: 'Master Products', value: 'master_products' },
                { label: 'Specific SKUs / Sellable Products', value: 'product_skus' },
            ],
            ruleScopeModes: [
                { label: 'All Products', value: 'all' },
                { label: 'Categories', value: 'categories' },
                { label: 'Brands', value: 'brands' },
                { label: 'Suppliers', value: 'suppliers' },
                { label: 'Master Products', value: 'master_products' },
                { label: 'Specific SKUs / Sellable Products', value: 'product_skus' },
            ],
            bogoRule: {
                buy: {
                    quantity: 1,
                    scope: { type: 'all', values: [] },
                },
                get: {
                    quantity: 1,
                    scope: { type: 'all', values: [] },
                },
                repeat: true,
            },
            bundleRule: {
                groups: [
                    {
                        id: 'group-1',
                        name: 'Group 1',
                        quantity: 1,
                        scope: { type: 'all', values: [] },
                    },
                    {
                        id: 'group-2',
                        name: 'Group 2',
                        quantity: 1,
                        scope: { type: 'all', values: [] },
                    },
                ],
                repeat: true,
            },

            // SKU pattern matching
            productSkus: [],
            skuPattern: '',
            patternMatchCount: 0,
            patternMatchProducts: [],
            showMatchingProducts: false,
            searchingByPattern: false,

            // Pagination for product SKUs
            productPage: 1,
            productTotalPages: 0,
            productTotalCount: 0,

            // For product SKUs mode (simplified approach)
            selectedProductObjects: [], // Store full product objects with SKUs

            isCustomerGroupPromotion: false,
        }
    },
    mounted() {
        this.setData({
            pageTitle: "Create Promotion",
        })
        this.applyCreateRoutePromotionType()
        this.ensureRuleDefaults()

        this.fetchData()

        // Preload all filter options in parallel for a more responsive UI
        Promise.all([
            this.searchCustomerGroups(""),
            this.searchBrands(""),
            this.searchSuppliers(""),
            this.searchCategories(""),
            this.searchMasterProducts("")
        ]).catch(err => {
            console.error("Error preloading filter options:", err)
        })
    },
    methods: {
        ...mapActions("misc", ["setData"]),
        applyCreateRoutePromotionType() {
            if (this.$route && this.$route.meta && this.$route.meta.promotionType && !this.$route.params.id) {
                this.promotionType = this.$route.meta.promotionType
            }
        },
        handlePromotionTypeChange() {
            this.ensureRuleDefaults()
            if (this.promotionType === 'bundle_discount' && this.rewardApplication === 'fixed_price') {
                this.setRewardApplication('amount_off')
            }
        },
        createEmptyScope(type = 'all') {
            return {
                type,
                values: [],
            }
        },
        createBundleGroup(index) {
            return {
                id: `group-${uuidv4()}`,
                name: `Group ${index + 1}`,
                quantity: 1,
                scope: this.createEmptyScope(),
            }
        },
        ensureRuleDefaults() {
            if (!this.bogoRule || !this.bogoRule.buy || !this.bogoRule.get) {
                this.bogoRule = {
                    buy: { quantity: 1, scope: this.createEmptyScope() },
                    get: { quantity: 1, scope: this.createEmptyScope() },
                    repeat: true,
                }
            }

            if (!this.bundleRule || !Array.isArray(this.bundleRule.groups) || this.bundleRule.groups.length < 2) {
                this.bundleRule = {
                    groups: [this.createBundleGroup(0), this.createBundleGroup(1)],
                    repeat: true,
                }
            }

            if (this.promotionType === 'bogo_discounted' || this.promotionType === 'bundle_discount') {
                this.productSelectionMode = 'all'
            }
        },
        hydrateRuleConfig(ruleConfig, promotionData = null) {
            const fallbackScope = promotionData ? this.scopeFromPromotionSelection(promotionData) : this.createEmptyScope()

            if (this.promotionType === 'bogo_discounted') {
                const getDiscount = ruleConfig && ruleConfig.get ? ruleConfig.get.discount : null
                if (getDiscount) {
                    this.rewardApplication = getDiscount.type || this.rewardApplication
                    this.rewardValue = Number(getDiscount.value !== undefined && getDiscount.value !== null ? getDiscount.value : this.rewardValue)
                    this.isPercentage = this.rewardApplication === 'percentage_off'
                }
                const buyScope = ruleConfig && ruleConfig.buy ? this.normalizeScopeForForm(ruleConfig.buy.scope) : fallbackScope
                const getScope = ruleConfig && ruleConfig.get ? this.normalizeScopeForForm(ruleConfig.get.scope) : fallbackScope

                this.bogoRule = {
                    buy: {
                        quantity: ruleConfig && ruleConfig.buy ? Number(ruleConfig.buy.quantity || 1) : 1,
                        scope: buyScope,
                    },
                    get: {
                        quantity: ruleConfig && ruleConfig.get ? Number(ruleConfig.get.quantity || 1) : 1,
                        scope: getScope,
                    },
                    repeat: !ruleConfig || ruleConfig.repeat !== false,
                }
                return
            }

            if (this.promotionType === 'bundle_discount') {
                if (ruleConfig && ruleConfig.discount) {
                    this.rewardApplication = ruleConfig.discount.type || this.rewardApplication
                    this.rewardValue = Number(ruleConfig.discount.value !== undefined && ruleConfig.discount.value !== null ? ruleConfig.discount.value : this.rewardValue)
                    this.isPercentage = this.rewardApplication === 'percentage_off'
                }
                if (ruleConfig && Array.isArray(ruleConfig.groups) && ruleConfig.groups.length >= 2) {
                    this.bundleRule = {
                        groups: ruleConfig.groups.map((group, index) => ({
                            id: group.id || `group-${index + 1}`,
                            name: group.name || `Group ${index + 1}`,
                            quantity: Number(group.quantity || 1),
                            scope: this.normalizeScopeForForm(group.scope),
                        })),
                        repeat: ruleConfig.repeat !== false,
                    }
                } else {
                    this.bundleRule = {
                        groups: [
                            {
                                id: 'group-1',
                                name: 'Group 1',
                                quantity: 1,
                                scope: this.normalizeScopeForForm(fallbackScope),
                            },
                            {
                                id: 'group-2',
                                name: 'Group 2',
                                quantity: 1,
                                scope: this.normalizeScopeForForm(fallbackScope),
                            },
                        ],
                        repeat: true,
                    }
                }
            }
        },
        scopeFromPromotionSelection(promotionData) {
            if (promotionData.categoryIds && promotionData.categoryIds.length) {
                return { type: 'categories', values: promotionData.categoryIds }
            }
            if (promotionData.brandIds && promotionData.brandIds.length) {
                return { type: 'brands', values: promotionData.brandIds }
            }
            if (promotionData.supplierIds && promotionData.supplierIds.length) {
                return { type: 'suppliers', values: promotionData.supplierIds }
            }
            if (promotionData.masterProductIds && promotionData.masterProductIds.length) {
                return { type: 'master_products', values: promotionData.masterProductIds }
            }
            if (promotionData.productSkus && promotionData.productSkus.length) {
                return { type: 'product_skus', values: promotionData.productSkus }
            }
            if (promotionData.productIds && promotionData.productIds.length && !promotionData.allProducts) {
                return { type: 'product_skus', values: promotionData.productIds }
            }
            return this.createEmptyScope()
        },
        normalizeScopeForForm(scope) {
            if (!scope || !scope.type) {
                return this.createEmptyScope()
            }
            const scopeType = scope.type === 'specific' ? 'product_skus' : scope.type
            return {
                type: scopeType,
                values: Array.isArray(scope.values) ? [...scope.values] : [],
            }
        },
        normalizeScopeForPayload(scope) {
            const normalizedScope = this.normalizeScopeForForm(scope)
            return {
                type: normalizedScope.type,
                values: normalizedScope.type === 'all' ? [] : normalizedScope.values,
            }
        },
        buildRuleConfig() {
            if (this.promotionType === 'bogo_discounted') {
                return {
                    buy: {
                        quantity: Number(this.bogoRule.buy.quantity),
                        scope: this.normalizeScopeForPayload(this.bogoRule.buy.scope),
                    },
                    get: {
                        quantity: Number(this.bogoRule.get.quantity),
                        scope: this.normalizeScopeForPayload(this.bogoRule.get.scope),
                        discount: {
                            type: this.rewardApplication,
                            value: Number(this.rewardValue),
                        },
                    },
                    repeat: this.bogoRule.repeat !== false,
                    applyTo: 'cheapest_eligible_get_item',
                }
            }

            if (this.promotionType === 'bundle_discount') {
                return {
                    groups: this.bundleRule.groups.map((group, index) => ({
                        id: group.id || `group-${index + 1}`,
                        name: group.name || `Group ${index + 1}`,
                        quantity: Number(group.quantity),
                        scope: this.normalizeScopeForPayload(group.scope),
                    })),
                    discount: {
                        type: this.rewardApplication,
                        value: Number(this.rewardValue),
                    },
                    repeat: this.bundleRule.repeat !== false,
                    allocation: 'proportional',
                }
            }

            return null
        },
        validateRuleBuilder() {
            if (this.promotionType !== 'bogo_discounted' && this.promotionType !== 'bundle_discount') {
                return ''
            }

            const discountValue = Number(this.rewardValue)
            if (!Number.isFinite(discountValue)) {
                return "Please enter a valid promotion discount value"
            }

            if (this.promotionType === 'bogo_discounted') {
                if (this.rewardApplication === 'fixed_price' && discountValue < 0.01) {
                    return "BOGO fixed price must be at least $0.01"
                }
                if (discountValue <= 0) {
                    return "BOGO discount must be greater than zero"
                }
                if (Number(this.bogoRule.buy.quantity) <= 0 || Number(this.bogoRule.get.quantity) <= 0) {
                    return "BOGO buy and get quantities must be greater than zero"
                }
                if (!this.isScopeValid(this.bogoRule.buy.scope)) {
                    return "Please select a buy scope for this BOGO promotion"
                }
                if (!this.isScopeValid(this.bogoRule.get.scope)) {
                    return "Please select a get scope for this BOGO promotion"
                }
                if (this.rewardApplication === 'percentage_off' && discountValue >= 100) {
                    return "BOGO percentage discount must be less than 100%"
                }
            }

            if (this.promotionType === 'bundle_discount') {
                if (!['percentage_off', 'amount_off'].includes(this.rewardApplication)) {
                    return "Bundle promotions support percentage or dollar discounts only"
                }
                if (discountValue <= 0) {
                    return "Bundle discount must be greater than zero"
                }
                if (this.rewardApplication === 'percentage_off' && discountValue >= 100) {
                    return "Bundle percentage discount must be less than 100%"
                }
                if (!this.bundleRule.groups || this.bundleRule.groups.length < 2) {
                    return "Bundle promotions need at least two groups"
                }
                const invalidGroup = this.bundleRule.groups.find((group) => Number(group.quantity) <= 0 || !this.isScopeValid(group.scope))
                if (invalidGroup) {
                    return "Every bundle group needs a quantity and scope"
                }
            }

            return ''
        },
        isScopeValid(scope) {
            if (!scope || !scope.type) {
                return false
            }
            return scope.type === 'all' || (Array.isArray(scope.values) && scope.values.length > 0)
        },
        handleRuleScopeTypeChange(scope) {
            this.$set(scope, 'values', [])
            const loaders = {
                categories: this.searchCategories,
                brands: this.searchBrands,
                suppliers: this.searchSuppliers,
                product_skus: this.searchProductsWithSKUs,
            }
            if (loaders[scope.type]) {
                loaders[scope.type]("")
            }
            if (scope.type === 'master_products') {
                this.masterProductSearchMessage = "Type at least 2 characters to search."
                this.searchingMasterProducts = false
            }
        },
        handleRuleScopeValues(scope, values) {
            this.$set(scope, 'values', values || [])
        },
        handleRuleScopeCommaInput(scope, value) {
            const values = `${value || ''}`
                .split(',')
                .map((entry) => entry.trim())
                .filter(Boolean)
            this.$set(scope, 'values', values)
        },
        addBundleGroup() {
            this.bundleRule.groups.push(this.createBundleGroup(this.bundleRule.groups.length))
        },
        removeBundleGroup(index) {
            if (this.bundleRule.groups.length <= 2) {
                return
            }
            this.bundleRule.groups.splice(index, 1)
        },
        getCurrentTimeHHMM() {
            const now = new Date();
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = now.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        toggleRecurringDate(recurringDate, weekdayId) {
            // Ensure daysOfWeek is an array for UI interaction
            if (!Array.isArray(recurringDate.daysOfWeek)) {
                // If it's a string from the backend, convert to array
                if (typeof recurringDate.daysOfWeek === 'string') {
                    recurringDate.daysOfWeek = recurringDate.daysOfWeek.split(',').filter(day => day.trim());
                } else {
                    recurringDate.daysOfWeek = [];
                }
            }

            // Find if the day is already selected
            const index = recurringDate.daysOfWeek.indexOf(weekdayId);

            if (index !== -1) {
                // Day is already selected, remove it
                this.$set(recurringDate, 'daysOfWeek',
                    recurringDate.daysOfWeek.filter(day => day !== weekdayId)
                );
            } else {
                // Day is not selected, add it
                this.$set(recurringDate, 'daysOfWeek',
                    [...recurringDate.daysOfWeek, weekdayId]
                );
            }
        },
        removeFrequency(id) {
            this.frequencies = this.frequencies.filter((item) => (item.id ? item.id != id : item.tempId != id))
        },
        addSpecificDate() {
            this.frequencies.push({
                type: FREQUENCY_DB_TYPES.SPECIFIC_DATE,
                specificDate: null,
                startTime: '09:00', // Default start time set to 9:00 AM
                endTime: '21:00',
                tempId: uuidv4(),
            })
        },
        addDateRange() {
            this.frequencies.push({
                type: FREQUENCY_DB_TYPES.DATE_RANGE,
                fromDate: null,
                toDate: null,
                startTime: '09:00', // Default start time set to 9:00 AM
                endTime: '21:00',
                tempId: uuidv4(),
            })
        },
        addRecurrenceDate() {
            const newRecurringFrequency = {
                type: FREQUENCY_DB_TYPES.RECURRING,
                recurrenceType: FREQUENCY_DB_RECURRENCE_TYPES.WEEK,
                fromDate: null,
                toDate: null,
                startTime: '09:00', // Default start time set to 9:00 AM
                endTime: '21:00',
                daysOfWeek: [], // Initialize as empty array for day selection
                recurrenceStartDateEnabled: false,
                recurrenceEndDateEnabled: false,
                tempId: uuidv4(),
            };

            this.frequencies.push(newRecurringFrequency);
        },
        addSelectedCustomerGroups(e) {
            if (e) {
                for (let item of e) {
                    if (!this.selectedCustomerGroups.includes(item)) {
                        this.selectedCustomerGroups.push(item)
                    }
                }
            }
        },
        addSelectedProducts(e) {
            if (e) {
                for (let item of e) {
                    if (!this.selectedProducts.includes(item)) {
                        this.selectedProducts.push(item)
                    }
                }
            }
        },
        handleSelectLocations(e) {
            this.selectedLocations = this.normalizeWarehouseIds(e);
        },
        normalizeWarehouseIds(value) {
            const values = Array.isArray(value) ? value : [value]
            return values.reduce((warehouseIds, entry) => {
                String(entry == null ? "" : entry).split(",").forEach(id => {
                    const normalizedId = id.trim()
                    if (normalizedId && normalizedId.toLowerCase() !== "null" && !warehouseIds.includes(normalizedId)) {
                        warehouseIds.push(normalizedId)
                    }
                })
                return warehouseIds
            }, [])
        },
        handleSelectProducts(e) {
            this.selectedProducts = e
        },
        handleSelectCustomerGroups(e) {
            this.selectedCustomerGroups = e
        },
        handleSelectCategories(e) {
            this.selectedCategories = e

            // Store the selected categories in local storage for quicker access when returning to this screen
            try {
                localStorage.setItem('promotions_selected_categories', JSON.stringify(e))
            } catch (err) {
                console.error("Error storing selected categories in cache:", err)
            }
        },
        handleSelectBrands(e) {
            this.selectedBrands = e;
        },
        handleSelectSuppliers(e) {
            this.selectedSuppliers = e
            console.log('Selected suppliers updated:', this.selectedSuppliers)
        },
        async searchCustomerGroups(e) {
            clearTimeout(this.customerSearchTimeout)
            this.customerSearchTimeout = setTimeout(async () => {
                try {
                    this.searchingCustomerGroups = true
                    // Fetch more customer groups with a larger limit for better selection options
                    const res = await http.get(`/customer-groups`, {
                        params: {
                            search: e || '',
                            start: 0,
                            limit: 50 // Increased from 12 to show more options
                        }
                    })

                    this.customerGroups = res.data.result
                } catch (err) {
                    console.error("Error fetching customer groups:", err);
                    this.$toast.error("Failed to load customer groups")
                }
                this.searchingCustomerGroups = false
            }, 500) // Reduced timeout for better responsiveness
        },
        async searchProductsWithSKUs(e, page = 1) {
            clearTimeout(this.productSearchTimeout)
            this.productSearchTimeout = setTimeout(async () => {
                try {
                    this.searchingProducts = true
                    // Use optimized promotion endpoint instead of /items
                    const res = await http.get(`/promotions/lookup/products-with-skus`, {
                        params: {
                            search: e,
                            limit: 100,
                            offset: (page - 1) * 100
                        }
                    })

                    const products = (res.data.result || []).map(product => {
                        const sku = product.item_code || product.sku || product.id
                        return {
                            id: sku,
                            title: product.name || product.item_name || sku,
                            sku,
                            productId: product.id,
                            originalData: product
                        }
                    })
                    this.cacheProductSkuOptions(products)
                    if (page > 1) {
                        const existingIds = new Set(this.products.map(product => product.id))
                        this.products = this.products.concat(products.filter(product => !existingIds.has(product.id)))
                    } else {
                        this.products = products
                    }
                    this.productPage = page
                    this.productTotalCount = Number(res.data.total || this.products.length)
                } catch (err) {
                    console.error("Error fetching products with SKUs:", err)
                    this.products = []
                }
                this.searchingProducts = false
            }, 600) // Increased debounce for better server performance
        },
        async searchProductsByPattern(pattern) {
            if (!pattern || pattern.length < 2) return;

            // Clear existing timeout for better debouncing
            clearTimeout(this.patternSearchTimeout);

            this.patternSearchTimeout = setTimeout(async () => {
                try {
                    this.searchingByPattern = true
                    const res = await http.get(`/promotions/lookup/product-variants-by-pattern?pattern=${encodeURIComponent(pattern)}&limit=100`)
                    this.patternMatchCount = res.data.result?.length || 0
                    this.patternMatchProducts = res.data.result || []
                } catch (err) {
                    console.error("Error fetching product variants by pattern:", err)
                    this.patternMatchCount = 0
                    this.patternMatchProducts = []
                }
                this.searchingByPattern = false
            }, 600); // Add debouncing for pattern search too
        },
        addSkuPattern() {
            if (!this.skuPattern) return;

            // Add asterisk if not already present
            let pattern = this.skuPattern;
            if (!pattern.includes('*')) {
                pattern = pattern + '*';
            }

            // Create a pattern object
            const patternObject = {
                id: `pattern-${Date.now()}`, // Generate unique ID
                title: `Pattern: ${pattern}`,
                sku: pattern,
                isPattern: true
            };

            // Add to selected products if not already there
            if (!this.selectedProductObjects.some(item => item.sku === pattern)) {
                this.selectedProductObjects.push(patternObject);

                // Also update productSkus array for compatibility
                this.productSkus.push(pattern);
            }

            this.skuPattern = '';
            this.patternMatchCount = 0;
            this.patternMatchProducts = [];
        },
        removeSkuPattern(pattern) {
            // Remove from both arrays
            this.selectedProductObjects = this.selectedProductObjects.filter(item =>
                item.isPattern ? item.sku !== pattern : true
            );
            this.productSkus = this.productSkus.filter(item => item !== pattern);
        },
        handleSelectProductsWithSKUs(selected) {
            // Store the full product objects including SKUs
            this.selectedProductObjects = selected

            // Also update productSkus array for compatibility with backend
            this.productSkus = selected.map(item => item.sku).filter(Boolean)
        },
        cacheProductSkuOptions(products) {
            products.forEach(product => {
                const sku = product.sku || product.item_code || product.id
                if (!sku) {
                    return
                }
                this.$set(this.productSkuOptionCache, sku, {
                    id: sku,
                    title: product.title || product.name || product.item_name || sku,
                    sku,
                })
            })
        },
        cacheMasterProductOptions(products) {
            products.forEach(product => {
                if (!product.id) {
                    return
                }
                this.$set(this.masterProductOptionCache, product.id, {
                    id: product.id,
                    title: product.title || product.name || product.item_name || product.item_code || product.id,
                })
            })
        },
        async searchCategories(e) {
            clearTimeout(this.categorySearchTimeout)

            // Check if we have cached categories and show them immediately while loading
            const cachedCategories = localStorage.getItem('promotions_categories_cache')
            if (cachedCategories && !e) {
                try {
                    this.categories = JSON.parse(cachedCategories)
                    console.log("Using cached categories while loading fresh data")
                } catch (err) {
                    console.error("Error parsing cached categories:", err)
                }
            }

            this.categorySearchTimeout = setTimeout(async () => {
                try {
                    this.searchingCategories = true
                    const res = await http.get(`/item-categories`, {
                        params: {
                            search: e || '',
                            limit: 100 // Increased limit for more comprehensive results
                        }
                    })
                    this.categories = res.data.result || []

                    // Cache the categories for future use if this is a full load (no search term)
                    if (!e) {
                        try {
                            localStorage.setItem('promotions_categories_cache', JSON.stringify(this.categories))
                        } catch (err) {
                            console.error("Error caching categories:", err)
                        }
                    }
                } catch (err) {
                    console.error("Error fetching categories:", err)
                    // If we have cached data and this fails, keep using cached data
                    if (!this.categories.length && !e) {
                        const cachedCategories = localStorage.getItem('promotions_categories_cache')
                        if (cachedCategories) {
                            try {
                                this.categories = JSON.parse(cachedCategories)
                                console.log("Using cached categories after fetch error")
                            } catch (parseErr) {
                                console.error("Error parsing cached categories:", parseErr)
                                this.categories = []
                            }
                        } else {
                            this.categories = []
                        }
                    }
                }
                this.searchingCategories = false
            }, 300) // Reduced timeout for better responsiveness
        },
        async searchBrands(e) {
            clearTimeout(this.brandSearchTimeout)
            this.brandSearchTimeout = setTimeout(async () => {
                try {
                    this.searchingBrands = true
                    const res = await http.get(`/promotions/lookup/brands`, {
                        params: {
                            search: e || '',
                            limit: 50
                        }
                    })
                    this.brands = res.data.result || []
                    // Log the exact structure of brands from the backend
                    console.log("EXACT BRAND DATA FROM BACKEND:", this.brands);
                } catch (err) {
                    console.error("Error fetching brands:", err)
                    this.brands = []; // Initialize as empty array on error
                }
                this.searchingBrands = false
            }, 1000)
        },
        async searchSuppliers(e) {
            clearTimeout(this.supplierSearchTimeout)
            this.supplierSearchTimeout = setTimeout(async () => {
                try {
                    this.searchingSuppliers = true
                    const res = await http.get(`/promotions/lookup/suppliers`, {
                        params: {
                            search: e || '',
                            limit: 50
                        }
                    })
                    this.suppliers = res.data.result || [];
                    console.log("Suppliers loaded:", this.suppliers)

                    // Log structure for debugging
                    if (this.suppliers.length > 0) {
                        console.log("Supplier data structure example:", this.suppliers[0]);
                    }
                } catch (err) {
                    console.error("Error fetching suppliers:", err)
                }
                this.searchingSuppliers = false
            }, 1000)
        },
        async searchMasterProducts(e) {
            clearTimeout(this.masterProductSearchTimeout)
            const search = `${e || ''}`.trim()
            if (search.length < 2) {
                this.searchingMasterProducts = false
                this.masterProductSearchMessage = "Type at least 2 characters to search."
                return
            }

            this.searchingMasterProducts = true
            this.masterProductSearchMessage = "Searching..."
            this.masterProductSearchTimeout = setTimeout(async () => {
                try {
                    const res = await http.get(`/promotions/lookup/master-products`, {
                        params: {
                            search,
                            limit: 50,
                        },
                    })
                    const masterProducts = (res.data.result || []).map(item => ({
                        id: item.id,
                        title: item.title || item.name || item.item_name || item.item_code || item.id,
                    }))
                    this.masterProducts = masterProducts
                    this.cacheMasterProductOptions(masterProducts)
                    this.masterProductSearchMessage = masterProducts.length ? "" : "No matching master products."
                } catch (err) {
                    console.error("Error fetching master products:", err)
                    this.masterProducts = []
                    this.masterProductSearchMessage = "Unable to load master products."
                } finally {
                    this.searchingMasterProducts = false
                }
            }, 500)
        },
        async fetchData() {
            try {
                const editId = this.$route.params.id || ""
                const copySourceId = !editId && this.$route.query ? this.$route.query.copyFrom || "" : ""
                const sourceId = editId || copySourceId
                if (!sourceId) {
                    this.loading = false
                    return
                }
                this.loading = true
                this.editId = editId

                const res = await http.get(`/promotions/${sourceId}`)

                const result = res.data.result

                // Normalize what comes back from the API so the form fields render cleanly.
                const normalizedFrequencies = normalizeFrequenciesFromApi(res.data.frequencies || [])

                const specificDates = []
                const dateRanges = []
                const recurringSchedules = []

                normalizedFrequencies.forEach((frequency) => {
                    const normalizedEntry = {
                        ...frequency,
                        tempId: frequency.tempId || uuidv4(),
                    }

                    if (copySourceId) {
                        delete normalizedEntry.id
                        delete normalizedEntry.promotionId
                        delete normalizedEntry.createdAt
                        delete normalizedEntry.updatedAt
                    }

                    if (normalizedEntry.type === FREQUENCY_DB_TYPES.SPECIFIC_DATE) {
                        specificDates.push(normalizedEntry)
                    } else if (normalizedEntry.type === FREQUENCY_DB_TYPES.DATE_RANGE) {
                        dateRanges.push(normalizedEntry)
                    } else if (normalizedEntry.type === FREQUENCY_DB_TYPES.RECURRING) {
                        recurringSchedules.push(normalizedEntry)
                    }
                })

                const combinedFrequencies = [
                    ...specificDates,
                    ...dateRanges,
                    ...recurringSchedules,
                ]

                this.frequencies = combinedFrequencies

                // Set the appropriate frequency tab based on the loaded data
                if (this.specificDatesFrequency.length > 0) {
                    this.frequency = FREQUENCIES.SPECIFIC_DATE;
                } else if (this.dateRangeFrequency.length > 0) {
                    this.frequency = FREQUENCIES.DATE_RANGE;
                } else if (this.recurringDatesFrequency.length > 0) {
                    this.frequency = FREQUENCIES.RECURRING;
                }

                this.editMode = Boolean(editId)

                this.name = copySourceId ? `${result.name} (Copy)` : result.name

                const warehouseIds = this.normalizeWarehouseIds(result.warehouseIds)
                // Legacy empty and string "null" values have always meant all locations at checkout.
                this.allLocations = result.allLocations === true || warehouseIds.length === 0;

                if (this.allLocations) {
                    // If using all locations, show all warehouses as selected for display
                    this.selectedLocations = this.warehouses.map(w => w.id);
                } else {
                    // Otherwise use the selected warehouse IDs
                    this.selectedLocations = warehouseIds;
                }

                // Set product selection mode
                this.productSelectionMode = result.productSelectionMode || 'all';

                // Load the appropriate product selection data based on mode
                if (result.allProducts) {
                    this.productSelectionMode = 'all';
                } else if (result.categoryIds && result.categoryIds.length > 0) {
                    this.productSelectionMode = 'categories';
                    this.selectedCategories = result.categoryIds || [];

                    // Eagerly load categories data since we're using it
                    this.searchCategories("");
                } else if (result.brandIds && result.brandIds.length > 0) {
                    this.productSelectionMode = 'brands';
                    this.selectedBrands = result.brandIds || [];
                } else if (result.supplierIds && result.supplierIds.length > 0) {
                    this.productSelectionMode = 'suppliers';
                    this.selectedSuppliers = result.supplierIds || [];

                    // Make sure we load supplier data for display purposes
                    this.searchSuppliers("");
                } else if (result.masterProductIds && result.masterProductIds.length > 0) {
                    this.productSelectionMode = 'master_products';
                    this.selectedMasterProducts = result.masterProductIds || [];

                    // Load master product details if IDs are present
                    if (this.selectedMasterProducts.length > 0) {
                        this.searchingMasterProducts = true;
                        try {
                            const res = await http.get('/promotions/lookup/master-products', {
                                params: {
                                    ids: this.selectedMasterProducts.join(','),
                                    limit: Math.max(this.selectedMasterProducts.length, 1),
                                },
                            });
                            const masterProducts = res.data.result || [];

                            // Filter to only include the selected master products
                            this.masterProducts = masterProducts
                                .filter(item => this.selectedMasterProducts.includes(item.id))
                                .map(item => ({
                                    id: item.id,
                                    title: `${item.title || item.name || item.item_name || item.id}${item.item_code ? ` (${item.item_code})` : ''}`
                                }));
                            this.cacheMasterProductOptions(this.masterProducts)
                        } catch (err) {
                            console.error("Error loading master products for editing:", err);
                        }
                        this.searchingMasterProducts = false;
                    }
                } else if (result.productSkus && result.productSkus.length > 0) {
                    this.productSelectionMode = 'product_skus';

                    // Create objects from SKUs - first store them in the compatibility array
                    this.productSkus = result.productSkus || [];

                    // Create objects for each SKU
                    this.selectedProductObjects = this.productSkus.map(sku => {
                        // Check if it's a pattern (contains *)
                        const isPattern = sku.includes('*');

                        return {
                            id: isPattern ? `pattern-${Date.now()}-${sku}` : `sku-${sku}`,
                            title: isPattern ? `Pattern: ${sku}` : `Product: ${sku}`,
                            sku: sku,
                            isPattern: isPattern
                        };
                    });

                    // Load product details for non-pattern SKUs
                    const nonPatternSkus = this.productSkus.filter(sku => !sku.includes('*'));
                    if (nonPatternSkus.length > 0) {
                        this.searchingProducts = true;
                        try {
                            // Load details for these SKUs
                            await this.searchProductsWithSKUs(''); // Load initial set of products

                            // Additional search for specific SKUs
                            for (const chunk of this.chunkArray(nonPatternSkus, 5)) {
                                // Search for each group of SKUs
                                const searchTerm = chunk.join(' ');
                                await this.searchProductsWithSKUs(searchTerm);
                            }
                        } catch (err) {
                            console.error("Error loading products for editing:", err);
                        }
                        this.searchingProducts = false;
                    }
                } else {
                    this.productSelectionMode = 'all';
                }

                this.selectedCustomerGroups = result.customerGroupIds || []
                this.rewardValue = result.rewardValue
                this.isPercentage = result.isPercentage
                this.promotionType = result.promotionType || "product_discount"
                this.discountMode = "best_price"
                this.rewardApplication = result.rewardApplication || (result.isPercentage ? "percentage_off" : "amount_off")
                this.showOnSalesDashboard = Boolean(result.showOnSalesDashboard)
                this.hydrateRuleConfig(result.ruleConfig, result)

                // Convert to proper boolean regardless of input format
                if (copySourceId) {
                    this.status = false
                } else if (typeof result.active === 'string') {
                    this.status = result.active.toLowerCase() === 'true';
                } else if (typeof result.active === 'number') {
                    this.status = result.active !== 0;
                } else {
                    // Handle as regular boolean or undefined/null
                    this.status = Boolean(result.active);
                }

                this.isCustomerGroupPromotion = Boolean(result.isCustomerGroupPromotion);

                if (copySourceId) {
                    this.setData({ pageTitle: "Copy Promotion" })
                }

            } catch (err) {
                console.error("Error fetching promotion data:", err);
            }
            this.loading = false
        },
        async updateData() {
            try {
                if (this.processing) return

                if (!this.name || !this.rewardValue) {
                    return this.$toast.error("Please fill in the mandatory values!")
                }

                const ruleValidationError = this.validateRuleBuilder()
                if (ruleValidationError) {
                    return this.$toast.error(ruleValidationError)
                }

                const activeFrequencyType = FREQUENCY_TYPES_BY_UI_TYPE[this.frequency]
                const activeFrequencies = this.frequencies.filter(frequency => frequency.type === activeFrequencyType)

                // The selected tab must always have at least one schedule, even when a
                // legacy promotion also contains valid schedules of other types.
                if (!activeFrequencyType || activeFrequencies.length === 0) {
                    return this.$toast.error("Please add at least one frequency for this promotion")
                }

                // Validate customer groups for customer group promotions
                if (this.isCustomerGroupPromotion && this.selectedCustomerGroups.length === 0) {
                    return this.$toast.error("Please select at least one customer group for this customer group promotion")
                }

                if (!this.isCustomerGroupPromotion && !this.allLocations && this.normalizeWarehouseIds(this.selectedLocations).length === 0) {
                    return this.$toast.error("Select at least one location or enable Apply to all locations")
                }

                // Validate specific dates
                if (this.frequency === FREQUENCIES.SPECIFIC_DATE) {
                    const invalidDates = activeFrequencies.filter(date => !date.specificDate);
                    if (invalidDates.length > 0) {
                        return this.$toast.error("Please select a date for all specific date entries")
                    }
                }

                // Validate date ranges - require at least one date (start OR end)
                if (this.frequency === FREQUENCIES.DATE_RANGE) {
                    const invalidRanges = activeFrequencies.filter(range => {
                        // Check if BOTH dates are null/undefined
                        return (!range.fromDate && !range.toDate)
                    });
                    if (invalidRanges.length > 0) {
                        return this.$toast.error("Please select at least a start or end date for all date ranges")
                    }
                }

                // Validate recurring dates
                if (this.frequency === FREQUENCIES.RECURRING) {
                    const invalidRecurring = activeFrequencies.filter(recurring => !recurring.daysOfWeek || recurring.daysOfWeek.length === 0);
                    if (invalidRecurring.length > 0) {
                        return this.$toast.error("Please select at least one day of the week for recurring promotions")
                    }
                }

                this.processing = true

                // Explicitly ensure status is boolean (not string, number, etc.)
                const activeStatus = Boolean(this.status);
                const usesRuleConfig = this.promotionType === 'bogo_discounted' || this.promotionType === 'bundle_discount'

                // Frequency inputs edit the canonical rows directly. Keeping that array intact
                // also preserves valid legacy promotions that already contain mixed rule types
                // until the user explicitly switches to a different frequency tab.
                const clonedFrequencies = JSON.parse(JSON.stringify(this.frequencies));

                // Convert frequency data to match backend requirements
                const processedFrequencies = clonedFrequencies.map(frequency => {
                    // Create a new object instead of modifying the existing one
                    const newFrequency = { ...frequency };

                    // For recurring frequencies, convert daysOfWeek array to comma-separated string
                    if (newFrequency.type === FREQUENCY_DB_TYPES.RECURRING) {
                        // Ensure daysOfWeek from UI gets to the backend as a string
                        if (Array.isArray(newFrequency.daysOfWeek) && newFrequency.daysOfWeek.length > 0) {
                            newFrequency.daysOfWeek = newFrequency.daysOfWeek.join(',');
                        } else {
                            newFrequency.daysOfWeek = '';
                        }

                        // Handle fromDate/toDate for recurring frequencies with enabled flags
                        if (!newFrequency.recurrenceStartDateEnabled) {
                            newFrequency.fromDate = null;
                        }

                        if (!newFrequency.recurrenceEndDateEnabled) {
                            newFrequency.toDate = null;
                        }

                        // Set recurrence type to week (required by backend)
                        newFrequency.recurrenceType = FREQUENCY_DB_RECURRENCE_TYPES.WEEK;
                    }

                    // Clean up properties that are only used on frontend
                    if (newFrequency.tempId) {
                        delete newFrequency.tempId;
                    }

                    return newFrequency;
                });

                // Prepare the payload according to the backend specifications
                const payload = {
                    name: this.name,
                    warehouseIds: this.isCustomerGroupPromotion ? [] : (this.allLocations ? [] : this.selectedLocations),
                    customerGroupIds: this.selectedCustomerGroups,
                    rewardValue: this.rewardValue,
                    isPercentage: this.rewardApplication === "percentage_off",
                    promotionType: this.promotionType,
                    discountMode: this.discountMode,
                    rewardApplication: this.rewardApplication,
                    showOnSalesDashboard: this.showOnSalesDashboard,
                    active: activeStatus,
                    frequencies: processedFrequencies,
                    allLocations: this.isCustomerGroupPromotion ? true : this.allLocations,
                    ruleConfig: this.buildRuleConfig(),

                    // Customer group and structured rule promotions define product targeting outside legacy productIds.
                    productSelectionMode: (this.isCustomerGroupPromotion || usesRuleConfig) ? 'all' : this.productSelectionMode,
                    allProducts: (this.isCustomerGroupPromotion || usesRuleConfig) ? true : (this.productSelectionMode === 'all'),

                    // Include appropriate IDs based on the mode
                    productIds: [],
                    categoryIds: (!this.isCustomerGroupPromotion && !usesRuleConfig && this.productSelectionMode === 'categories') ? this.selectedCategories : [],
                    brandIds: (!this.isCustomerGroupPromotion && !usesRuleConfig && this.productSelectionMode === 'brands') ? this.selectedBrands : [],
                    supplierIds: (!this.isCustomerGroupPromotion && !usesRuleConfig && this.productSelectionMode === 'suppliers') ? this.selectedSuppliers : [],
                    masterProductIds: (!this.isCustomerGroupPromotion && !usesRuleConfig && this.productSelectionMode === 'master_products') ? this.selectedMasterProducts : [],
                    productSkus: (!this.isCustomerGroupPromotion && !usesRuleConfig && this.productSelectionMode === 'product_skus') ? this.selectedProductObjects.map(item => item.sku).filter(Boolean) : [],

                    // Add a flag to indicate this is a customer group promotion
                    isCustomerGroupPromotion: this.isCustomerGroupPromotion
                }

                // Log debug information for brands and suppliers if needed
                if (this.productSelectionMode === 'brands') {
                    console.log('Sending brand promotion with brand names:', payload.brandIds);
                }

                if (this.productSelectionMode === 'suppliers') {
                    console.log('Sending supplier promotion with supplier IDs:', payload.supplierIds);
                }

                if (!this.editId) {
                    const response = await http.post(`/promotions`, payload);
                    this.$toast.success("Created Successfully")
                } else {
                    const response = await http.patch(`/promotions/${this.editId}`, payload);
                    this.$toast.success("Updated Successfully")
                }
                this.$router.push("/promotions")
            } catch (err) {
                console.error("Error saving promotion:", err);
                const saveError = err && err.response && err.response.data
                    ? (err.response.data.error || err.response.data.message)
                    : null
                this.$toast.error(saveError || "Unable to save promotion. Please try again.")
            }
            this.processing = false
        },
        async cancel() {
            const confirmed = await confirmDialog({
                title: "Leave promotion editor?",
                text: "Unsaved promotion changes will be discarded.",
                confirmButtonText: "Leave editor",
            })
            if (confirmed) {
                this.$router.push("/promotions")
            }
        },
        handleAllLocationsChange() {
            if (this.allLocations) {
                // When all locations is checked, select all warehouses for UI display purposes
                this.selectedLocations = this.warehouses.map(w => w.id);
            } else {
                // Clear the selections when unchecked
                this.selectedLocations = [];
            }
        },
        setProductSelectionMode(mode) {
            this.productSelectionMode = mode

            // When switching to a different mode, preload the relevant data
            if (mode === 'product_skus') {
                // Only preload empty search to get initial products
                this.searchProductsWithSKUs("");
            } else if (mode === 'master_products') {
                this.searchMasterProducts();
            } else if (mode === 'brands') {
                // Refresh brands data when brands mode is selected
                this.searchBrands("");
            } else if (mode === 'suppliers') {
                // Refresh suppliers data when suppliers mode is selected
                this.searchSuppliers("");
            } else if (mode === 'categories') {
                // For categories mode, use cached data immediately if available
                const cachedCategories = localStorage.getItem('promotions_categories_cache')
                if (cachedCategories) {
                    try {
                        this.categories = JSON.parse(cachedCategories)
                        console.log("Using cached categories for immediate display")

                        // Then refresh in the background
                        setTimeout(() => {
                            this.searchCategories("");
                        }, 100)
                    } catch (err) {
                        console.error("Error parsing cached categories:", err)
                        this.searchCategories("");
                    }
                } else {
                    // If no cache, load immediately
                    this.searchCategories("");
                }

                // Restore any previously selected categories if available
                const savedSelectedCategories = localStorage.getItem('promotions_selected_categories')
                if (savedSelectedCategories && !this.selectedCategories.length) {
                    try {
                        this.selectedCategories = JSON.parse(savedSelectedCategories)
                    } catch (err) {
                        console.error("Error restoring selected categories:", err)
                    }
                }
            }
        },
        toggleStatus() {
            // Force conversion to boolean and then invert
            this.status = !(this.status === true);
        },
        syncPercentFlag() {
            this.isPercentage = this.rewardApplication === "percentage_off"
        },
        setRewardApplication(value) {
            this.rewardApplication = value
            this.syncPercentFlag()
        },
        setFrequencyType(type) {
            const dbType = FREQUENCY_TYPES_BY_UI_TYPE[type]
            if (!dbType || this.frequency === type) return

            // Choosing a different tab is the explicit boundary where the single-type UI
            // replaces other schedules. A no-op save keeps legacy mixed schedules intact.
            this.frequencies = this.frequencies.filter(frequency => frequency.type === dbType)

            if (this.frequencies.length === 0) {
                if (type === FREQUENCIES.SPECIFIC_DATE) this.addSpecificDate()
                if (type === FREQUENCIES.DATE_RANGE) this.addDateRange()
                if (type === FREQUENCIES.RECURRING) this.addRecurrenceDate()
            }

            if (type === FREQUENCIES.RECURRING) {
                this.frequencies.forEach(freq => {
                    if (!Array.isArray(freq.daysOfWeek)) {
                        freq.daysOfWeek = typeof freq.daysOfWeek === 'string'
                            ? freq.daysOfWeek.split(',').filter(day => day.trim())
                            : []
                    }
                    if (typeof freq.recurrenceStartDateEnabled === 'undefined') {
                        this.$set(freq, 'recurrenceStartDateEnabled', !!freq.fromDate)
                    }
                    if (typeof freq.recurrenceEndDateEnabled === 'undefined') {
                        this.$set(freq, 'recurrenceEndDateEnabled', !!freq.toDate)
                    }
                })
            }

            this.frequency = type
        },
        // Handle load more products when scrolling
        handleLoadMoreProducts(search, page) {
            console.log(`Loading more products, page ${page}, search: "${search}"`);
            this.searchProductsWithSKUs(search, page);
        },
        // Helper method to chunk arrays for batch processing
        chunkArray(array, size) {
            const chunked = [];
            for (let i = 0; i < array.length; i += size) {
                chunked.push(array.slice(i, i + size));
            }
            return chunked;
        },
        handleCustomerGroupPromotionChange() {
            if (this.isCustomerGroupPromotion) {
                // Force select "all products" and "all locations" when customer group promotion is enabled
                this.allLocations = true;
                this.productSelectionMode = 'all';
            }
        },
    },
    computed: {
        ...mapState("misc", ["provinces", "taxes", "warehouses", "itemGroups"]),
        availableRewardApplicationOptions() {
            if (this.promotionType === 'bundle_discount') {
                return this.rewardApplicationOptions.filter(option => option.value !== 'fixed_price')
            }
            return this.rewardApplicationOptions
        },
        discountValueLabel() {
            if (this.rewardApplication === 'percentage_off') {
                return 'Percent off'
            }
            if (this.rewardApplication === 'fixed_price') {
                return 'Discounted price'
            }
            return 'Dollar amount off'
        },
        discountValuePrefix() {
            return this.rewardApplication === 'percentage_off' ? '' : '$'
        },
        discountValueSuffix() {
            return this.rewardApplication === 'percentage_off' ? '%' : ''
        },
        discountValueMinimum() {
            return 0.01
        },
        discountValueMaximum() {
            if (
                (this.promotionType === 'bogo_discounted' || this.promotionType === 'bundle_discount')
                && this.rewardApplication === 'percentage_off'
            ) {
                return 99.99
            }
            return null
        },
        discountValueHelp() {
            if (this.promotionType === 'bogo_discounted') {
                if (this.rewardApplication === 'percentage_off') {
                    return 'BOGO discounts must be greater than 0% and less than 100%.'
                }
                if (this.rewardApplication === 'fixed_price') {
                    return 'Sets the cheapest eligible product to this non-zero price.'
                }
                return 'Deducts this amount while keeping the cheapest eligible product at $0.01 or more.'
            }
            if (this.promotionType === 'bundle_discount') {
                if (!['percentage_off', 'amount_off'].includes(this.rewardApplication)) {
                    return 'Choose percentage or dollar amount off for Bundle promotions.'
                }
                if (this.rewardApplication === 'percentage_off') {
                    return 'Applies this percentage to the complete bundle total. Must be less than 100%.'
                }
                return 'Deducts this amount from the complete bundle total while keeping it at $0.01 or more.'
            }
            if (this.rewardApplication === 'percentage_off') {
                return 'Percentage deducted from each eligible product.'
            }
            if (this.rewardApplication === 'fixed_price') {
                return 'Final price for each eligible product.'
            }
            return 'Dollar amount deducted from each eligible product.'
        },
        specificDatesFrequency() {
            return this.frequencies.filter(item => item.type === FREQUENCY_DB_TYPES.SPECIFIC_DATE)
        },
        dateRangeFrequency() {
            return this.frequencies.filter(item => item.type === FREQUENCY_DB_TYPES.DATE_RANGE)
        },
        recurringDatesFrequency() {
            return this.frequencies.filter(item => item.type === FREQUENCY_DB_TYPES.RECURRING)
        },
        locationOptions() {
            return this.warehouses
                ? this.warehouses.map((item) => ({
                      id: item.id,
                      title: item.name,
                  }))
                : []
        },
        customerGroupOptions() {
            return this.customerGroups.map(group => ({
                id: group.id,
                title: group.customer_group_name || group.name,
                // Add additional information if available
                subtitle: group.discount ? `Discount: ${group.discount}%` : ''
            }));
        },
        categoryOptions() {
            return this.categories.map(category => ({
                id: category.id,
                title: category.name
            }));
        },
        brandOptions() {
            if (!this.brands || !this.brands.length) return [];

            // Use brand NAME as the ID value
            // This matches how products store brand information
            return this.brands.map((brand) => {
                // The name is the important value that needs to match the product's brand field
                const brandName = brand.name || brand.brandName || brand.title || `Brand #${brand.id}`;

                return {
                    // Use the brand NAME as the value/ID
                    id: brandName,
                    // Display the same name in the UI
                    title: brandName
                };
            });
        },
        supplierOptions() {
            if (!this.suppliers || !this.suppliers.length) return [];

            return this.suppliers.map((supplier) => {
                // Use the actual supplier ID as the value/ID
                const supplierId = supplier.id;
                // The name is used for display in the UI
                const supplierName = supplier.name || supplier.supplierName || supplier.companyName || supplier.title || `Supplier #${supplier.id}`;

                return {
                    // Use the supplier ID as the value
                    id: supplierId,
                    // Display the name in the UI
                    title: supplierName
                };
            });
        },
        productSkuOptions() {
            const options = this.products.map(product => {
                const sku = product.sku || product.item_code || product.id
                return {
                    id: sku,
                    title: product.title || product.name || sku,
                    sku,
                }
            });
            Object.values(this.productSkuOptionCache || {}).forEach(option => {
                if (!options.some(existingOption => existingOption.id === option.id)) {
                    options.push(option)
                }
            })
            const optionIds = new Set(options.map(option => option.id))
            const selectedValues = [
                ...(this.bogoRule.buy.scope.type === 'product_skus' ? this.bogoRule.buy.scope.values : []),
                ...(this.bogoRule.get.scope.type === 'product_skus' ? this.bogoRule.get.scope.values : []),
                ...this.bundleRule.groups.reduce((values, group) => {
                    return group.scope.type === 'product_skus' ? values.concat(group.scope.values) : values
                }, []),
            ]

            selectedValues.forEach(value => {
                if (value && !optionIds.has(value)) {
                    options.push({
                        id: value,
                        title: `SKU: ${value}`,
                        sku: value,
                    })
                    optionIds.add(value)
                }
            })

            return options
        },
        masterProductOptions() {
            const options = this.masterProducts.map(product => ({
                id: product.id,
                title: product.title || product.name || product.item_code || product.id,
            }))
            Object.values(this.masterProductOptionCache || {}).forEach(option => {
                if (!options.some(existingOption => existingOption.id === option.id)) {
                    options.push(option)
                }
            })
            const optionIds = new Set(options.map(option => option.id))
            const selectedValues = [
                ...this.selectedMasterProducts,
                ...(this.bogoRule.buy.scope.type === 'master_products' ? this.bogoRule.buy.scope.values : []),
                ...(this.bogoRule.get.scope.type === 'master_products' ? this.bogoRule.get.scope.values : []),
                ...this.bundleRule.groups.reduce((values, group) => {
                    return group.scope.type === 'master_products' ? values.concat(group.scope.values) : values
                }, []),
            ]

            selectedValues.forEach(value => {
                if (value && !optionIds.has(value)) {
                    options.push({
                        id: value,
                        title: `Master product: ${value}`,
                    })
                    optionIds.add(value)
                }
            })

            return options
        },
    },
    watch: {
        // Watch for changes to status to ensure the toggle always shows the correct state
        status(newVal) {
            // No need to force conversion here, the toggleStatus method handles this
        },
        promotionType() {
            this.ensureRuleDefaults()
        },
    },
}
